import type { StateCreator } from 'zustand';

import type { StreakSlice } from './types';

export type { StreakSlice } from './types';

export const streakInitialState = {
  isStreakSheetOpen: false,
  isStreakCelebrationOpen: false,
};

export const createStreakSlice: StateCreator<
  StreakSlice,
  [],
  [],
  StreakSlice
> = () => ({
  ...streakInitialState,
});
